import { render, staticRenderFns } from "./WorkExperiences.vue?vue&type=template&id=35566a2c&scoped=true&"
import script from "./WorkExperiences.vue?vue&type=script&lang=js&"
export * from "./WorkExperiences.vue?vue&type=script&lang=js&"
import style0 from "./WorkExperiences.vue?vue&type=style&index=0&id=35566a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35566a2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
